import React from "react"
import {
  Home,
  Archive,
  AlertCircle,
  Map,
  Plus,
  FileText,
  UserCheck,
  List,
  Calendar,
  User,
  Users,
  PieChart,
  Tag,
  Clock,
  ShoppingBag,
  Package
} from "react-feather"

const navigationConfig = [
  {
    type: "groupHeader",
    groupTitle: "Dashboard",
    permissions: ["admin", "store", "editor"]
  },
  {
    id: "home",
    title: "Home",
    type: "item",
    icon: <Home size={20} />,
    permissions: ["admin", "store", "editor"],
    navLink: "/"
  },
  {
    id: "locations",
    title: "Locations",
    type: "item",
    icon: <Map size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/locations"
  },
  {
    type: "groupHeader",
    groupTitle: "Assets",
    permissions: []
  },
  {
    id: "dashboard-assets",
    title: "Dashboard",
    type: "item",
    icon: <PieChart size={16} />,
    permissions: [],
    navLink: "/dashboard-assets"
  },
  {
    id: "assets",
    title: "Assets",
    type: "item",
    icon: <Tag size={16} />,
    permissions: [],
    navLink: "/assets"
  },
  {
    id: "asset-logs",
    title: "Asset Logs",
    type: "item",
    icon: <FileText size={16} />,
    permissions: [],
    navLink: "/assets-logs"
  },
  {
    id: "assetCategories",
    title: "Asset Categories",
    type: "item",
    icon: <List size={16} />,
    permissions: [],
    navLink: "/asset-categories"
  },
  {
    id: "asset-users",
    title: "Asset Users",
    type: "item",
    icon: <User size={16} />,
    permissions: [],
    navLink: "/asset-users"
  },
  {
    id: "user-groups-assets",
    title: "User Groups",
    type: "item",
    icon: <Users size={16} />,
    permissions: [],
    navLink: "/user-groups-assets"
  },
  {
    id: "schedules",
    title: "Schedules",
    type: "item",
    icon: <Clock size={16} />,
    permissions: [],
    navLink: "/schedules"
  },
  {
    type: "groupHeader",
    groupTitle: "Office",
    permissions: ["admin", "editor"]
  },
  {
    id: "dashboard",
    title: "Dashboard",
    type: "item",
    icon: <PieChart size={16} />,
    permissions: ["admin", "editor"],
    navLink: "/dashboard-office"
  },
  {
    id: "users",
    title: "Users",
    type: "item",
    icon: <User size={16} />,
    permissions: ["admin", "editor"],
    navLink: "/office-users"
  },
  {
    id: "user-groups-office",
    title: "User Groups",
    type: "item",
    icon: <Users size={16} />,
    permissions: [],
    navLink: "/user-groups-office"
  },
  {
    id: "activity",
    title: "Activity",
    type: "item",
    icon: <FileText size={16} />,
    permissions: ["admin", "editor"],
    navLink: "/activity"
  },
  {
    id: "expiredLockers",
    title: "Expired Lockers",
    type: "item",
    icon: <Clock size={16} />,
    permissions: ["admin", "editor"],
    navLink: "/expired-lockers"
  },
  {
    type: "groupHeader",
    groupTitle: "Orders",
    permissions: ["admin", "store", "editor"]
  },
  {
    id: "dashboard-delivery",
    title: "Dashboard",
    type: "item",
    icon: <PieChart size={16} />,
    permissions: ["admin", "store", "editor"],
    navLink: "/dashboard-delivery"
  },
  {
    id: "new-order",
    title: "New Order",
    type: "item",
    icon: <Plus size={16} />,
    permissions: [],
    navLink: "/orders/details/new"
  },
  {
    id: "orders",
    title: "Orders List",
    type: "item",
    icon: <List size={16} />,
    permissions: ["admin"],
    navLink: "/orders"
  },
  {
    id: "deposited-orders",
    title: "Deposited Orders",
    type: "item",
    icon: <Package size={16} />,
    permissions: ["admin", "store", "editor"],
    navLink: "/deposited-orders"
  },
  {
    id: "orders-history",
    title: "Orders History",
    type: "item",
    icon: <Calendar size={16} />,
    permissions: ["admin", "store", "editor"],
    navLink: "/orders-history"
  },
  {
    id: "archived-orders",
    title: "Archived Orders",
    type: "item",
    icon: <Archive size={16} />,
    permissions: ["admin", "store", "editor"],
    navLink: "/archived-orders"
  },
  {
    id: "orders_logs",
    title: "Orders Logs",
    type: "item",
    icon: <FileText size={16} />,
    permissions: ["admin", "store", "editor"],
    navLink: "/orders-logs"
  },
  {
    id: "expiredLockersDelivery",
    title: "Expired Lockers Delivery",
    type: "item",
    icon: <Clock size={16} />,
    permissions: ["admin", "editor"],
    navLink: "/expired-lockers-delivery"
  },
  {
    id: "delivery-analytics",
    title: "Delivery Analytics",
    type: "item",
    icon: <PieChart size={16} />,
    permissions: ["admin", "editor"],
    navLink: "/delivery-analytics"
  },
  {
    type: "groupHeader",
    groupTitle: "Notifications",
    permissions: ["admin", "editor"]
  },
  {
    id: "alerts",
    title: "Alerts",
    type: "item",
    icon: <AlertCircle size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/alerts"
  },
  {
    id: "locationsDetails",
    title: null,
    type: "hidden",
    icon: null,
    permissions: ["admin", "editor"],
    navLink: "/locations/details/:id"
  },
  {
    type: "groupHeader",
    groupTitle: "Administration",
    permissions: ["admin", "store", "editor"]
  },
  {
    id: "admins",
    title: "Admins",
    type: "item",
    icon: <UserCheck size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/admins"
  },
  {
    id: "employees",
    title: "Employees",
    type: "item",
    icon: <UserCheck size={20} />,
    permissions: ["store"],
    navLink: "/employees"
  },
  {
    id: "projects",
    title: "Projects",
    type: "item",
    icon: <ShoppingBag size={20} />,
    permissions: [],
    navLink: "/projects"
  },
  {
    id: "holidays",
    title: "Holidays",
    type: "item",
    icon: <Calendar size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/admins/holidays"
  },
  {
    id: "adminsLogs",
    title: "Admins Logs",
    type: "item",
    icon: <FileText size={20} />,
    permissions: ["admin", "editor"],
    navLink: "/admins/logs"
  },
  {
    id: "newLocation",
    title: "New Location",
    type: "item",
    icon: <Map size={20} />,
    permissions: [],
    navLink: "/locations/config/new"
  },
  /*{
    id: "import-orders",
    title: "Import Orders",
    type: "item",
    icon: <UploadCloud size={20} />,
    permissions: ["admin", "store", "editor"],
    navLink: "/import-orders"
  },*/
  /*{
    id: "administration",
    title: "Administration",
    icon: <Settings size={20} />,
    type: "collapse",
    children: [
      {
        id: "admins",
        title: "Admins",
        type: "item",
        icon: <UserCheck size={20} />,
        permissions: ["admin", "store", "editor"],
        navLink: "/admins"
      },
      {
        id: "projects",
        title: "Projects",
        type: "item",
        icon: <Disc size={20} />,
        permissions: ["admin", "store", "editor"],
        navLink: "/projects"
      },
      {
        id: "userType",
        title: "User Type",
        type: "item",
        icon: <Disc size={20} />,
        permissions: ["admin", "store", "editor"],
        navLink: "/user-type"
      },
      {
        id: "service",
        title: "Service",
        type: "item",
        icon: <Disc size={20} />,
        permissions: ["admin", "store", "editor"],
        navLink: "/service"
      }
    ]
  },*/
  {
    id: "usersDetails",
    title: null,
    type: "hidden",
    icon: null,
    permissions: ["admin", "editor"],
    navLink: "/users/details/:id"
  },
  /*{
    id: "serviceStatus",
    title: "Service Status",
    type: "item",
    icon: <Server size={20} />,
    permissions: ["admin", "store", "editor"],
    navLink: "/service-status"
  },*/
  /*{
  id: "support",
  title: "Support",
  type: "item",
  icon: <LifeBuoy size={20} />
  },
  {
    id: "docs",
    title: "Documentation",
    type: "item",
    icon: <FileText size={20} />,
    permissions: ["admin", "store", "editor"],
  },
  {
    id: "faq",
    title: "FAQ",
    type: "item",
    icon: <HelpCircle size={20} />,
    permissions: ["admin"],
  }*/
]

export default navigationConfig
